module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#bundle",
      toString: function () {
        return this.url;
      }
    }